// extracted by mini-css-extract-plugin
module.exports = {"Aspect16x9":"Announcement_Aspect16x9__3v1fJ","CardImg":"Announcement_CardImg__3wGs_"};